import { render, staticRenderFns } from "./LayoutHeaderless.vue?vue&type=template&id=46927847"
import script from "./LayoutHeaderless.vue?vue&type=script&lang=js"
export * from "./LayoutHeaderless.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46927847')) {
      api.createRecord('46927847', component.options)
    } else {
      api.reload('46927847', component.options)
    }
    module.hot.accept("./LayoutHeaderless.vue?vue&type=template&id=46927847", function () {
      api.rerender('46927847', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/_layouts/layout-headerless/LayoutHeaderless.vue"
export default component.exports